import classNames from "classnames";
import styles from "./CloseButton.module.css";

//#region [Props]
type CloseButtonProps = {
    $isOpen: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
//#endregion

//#region [Component]
export default function SCloseButton({ $isOpen, className = "", ...props }: CloseButtonProps) {
    return (
        <button
            type="button"
            className={classNames(styles.sCloseButton, $isOpen ? styles.open : null, className)}
            {...props}
        />
    );
}
//#endregion